import React, {useContext, useEffect} from "react";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import UpdateContactInfo from "./UpdateContactInfo";
import PrintInvoice1 from "./PrintInvoice1";
import BackToEstimate from "./BackToEstimate";
import PrintInvoice from "../CommonComponents/PrintInvoiceCommonButton";
import PayInvoiceForInvoice from "../CommonComponents/PayInvoiceForInvoice";

export default () => {//this component shows the header buttons i.e (update ,print and Back)
    let Record = useContext(RecordsManagementContext)
    let IV1_PageDetails = Record.IV1_PageDetails
    let PageView = useContext(ViewMangementContext)
    const ShowTermsAndConditions = () => {
        PageView.Set('SHOW BACK PAGE')
    }
    useEffect(() => {
        window.addEventListener('scroll', stickyHead);
        return () => {
            window.removeEventListener('scroll', stickyHead);
        };
    });
    const stickyHead = (e) => {
        const header = document.querySelector('.sticky-head');
        const scrollTop = window.scrollY;
        scrollTop  > 0 ? header.setAttribute('style', 'top: 0; border-bottom: #17a2b8 2px solid !important;')  : header.setAttribute('style', 'top: 0; border-bottom: 0px;');
    };
    const show_addendum = (e) => {
        Record.setSelectedAddendum(e.target.value)
        PageView.Set('SHOW ADDENDUM')
    }
    return (
        <>
            <table className="table">
                <thead className="sticky-head">
                <tr>
                    <th className="th-main-bost-2" style={{width:"1349px"}}>
                        <table className="table">
                            <tbody>
                            <tr>
                                <td className="td-main-bost"><BackToEstimate/></td>
                                <td  className="td-main-bost" style={{textAlign: "center"}}>
                                    <b>This Estimate is Booked For - {IV1_PageDetails.ServiceDate} </b>
                                </td>
                                <td className="td-main-bost" style={{float: "right"}}>
                                    {IV1_PageDetails.AddendumPresent ?
                                        <select className="custom-select addendum-select-1" onChange={(e) =>show_addendum(e)}
                                               >
                                            <option defaultValue="Select Addendum">Select Addendum</option>
                                            {Object.keys(IV1_PageDetails.AddendumData).map((addendum_name,key) => {
                                                return (
                                                    <option key={key+"addendum_name"}
                                                            value={IV1_PageDetails.AddendumData[addendum_name].id}>
                                                        {IV1_PageDetails.AddendumData[addendum_name].name}</option>
                                                )
                                            })}
                                        </select>
                                        :<></>}
                                    <PayInvoiceForInvoice />
                                    <PrintInvoice />
                                    <button  className='btn btn-dark btn-sm ' onClick={()=> ShowTermsAndConditions()}>
                                        <b>SHOW BACK PAGE</b></button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </th>
                </tr>
                </thead>
                <tbody>
                <div className="client_name">
                    <b className="customer_name">{IV1_PageDetails.ClientName}</b>
                </div>
                </tbody>
            </table>
        </>
    )
}